"use client";

import DemoNote from "@/components/ui/DemoNote";
import { useI18n } from "@/i18n/I18nProvider";

export default function DemoBar() {
  const { t } = useI18n();
  return <DemoNote text={t("Demo data notice")} className="mb-1" />;
}
